import React from "react";
import Footer from "../footer/Footer";
import VTUserCode from "../page/VTUserCode";
import Header from "../header/Header";

/**
 * Displays User Customer Code and QR Code
 * @returns {JSX.Element}
 * @constructor
 */
export default function LandingUserCode() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTUserCode/>
            <Footer/>
        </>
    );
}